import { Mail } from "lucide-react";
import { SEO } from "@/lib/seo";
import { PageHero } from "@/components/common/PageHero";
import { Reveal } from "@/components/common/Reveal";
import { ContactForm } from "@/components/contact/ContactForm";
import { SITE } from "@/config/site";

export default function Contact() {
  return (
    <div data-testid="contact-page">
      <SEO
        title="Contact & Media Enquiries"
        description="Get in touch with WomensMatchDayLive for match commentary, club enquiries, media, sponsorship and collaboration opportunities."
        path="/contact"
      />
      <PageHero eyebrow="Contact" title="Contact" subtitle="Match commentary, club enquiries, media and sponsorship — get in touch." crumbLabel="Contact" />

      <section className="bg-brand-black py-20">
        <div className="mx-auto grid max-w-6xl gap-12 px-6 lg:grid-cols-[1fr_1.4fr] lg:px-12">
          <Reveal>
            <h2 className="font-heading text-3xl uppercase text-white">Get In Touch</h2>
            <p className="mt-4 text-white/60">Text goes here</p>
            <div className="mt-8 flex items-center gap-2 border border-border-dark p-4 text-white/70">
              <Mail className="h-4 w-4 shrink-0 text-brand-purple" />
              <span data-testid="contact-page-email">{SITE.contactEmail}</span>
            </div>
          </Reveal>
          <Reveal delay={0.1}>
            <ContactForm />
          </Reveal>
        </div>
      </section>
    </div>
  );
}
